/**
 * Small shared formatters for the "created by … · date" line shown on project
 * and pipeline cards. The creator's display name / email is resolved server-
 * side at view time (never stored — GDPR crypto-shredding), so it can be
 * absent for system/unknown/erased actors → a dash.
 */

/** Human creator label: display name, then email, then a dash. */
export function creator(who: {
  created_by_display_name?: string | null;
  created_by_email?: string | null;
}): string {
  return who.created_by_display_name || who.created_by_email || "—";
}

/** Short, locale-aware creation date. */
export function createdOn(isoUtc: string): string {
  return new Date(isoUtc).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
